import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=0ed5515c&"
import script from "./AccountButton.vue?vue&type=script&lang=js&"
export * from "./AccountButton.vue?vue&type=script&lang=js&"
import style0 from "./AccountButton.vue?vue&type=style&index=0&id=0ed5515c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports